import { Component, OnInit, AfterViewInit, ViewChild, ViewContainerRef, TemplateRef, ComponentFactoryResolver, ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { AspLoadingComponent } from '../asp-loading/asp-loading.component';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { AspLoginService } from '../asp-login/asp-login.service';
import { AspRequestWishlistService } from './asp-request-wishlist.service';
import { AspCartService } from '../asp-cart/asp-cart.service';
import { AspInstantOrderQuoteService } from '../asp-instant-order-quote/asp-instant-order-quote.service';

@Component({
  selector: 'app-asp-request-wishlist',
  templateUrl: './asp-request-wishlist.component.html',
  styleUrls: ['./asp-request-wishlist.component.scss'],
  animations: [
    trigger('shakeit', [
      state('shakestart', style({ transform: 'scale(1)' })),
      state('shakeend', style({ transform: 'scale(1)' })),
      transition('shakestart => shakeend', animate('1000ms ease-in', keyframes([
        style({ transform: 'translate3d(-1px, 0, 0)', offset: 0.1 }),
        style({ transform: 'translate3d(2px, 0, 0)', offset: 0.2 }),
        style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.3 }),
        style({ transform: 'translate3d(4px, 0, 0)', offset: 0.4 }),
        style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.5 }),
        style({ transform: 'translate3d(4px, 0, 0)', offset: 0.6 }),
        style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.7 }),
        style({ transform: 'translate3d(2px, 0, 0)', offset: 0.8 }),
        style({ transform: 'translate3d(-1px, 0, 0)', offset: 0.9 }),
      ]))),
    ])
  ]
})
export class AspRequestWishlistComponent implements OnInit, AfterViewInit {

  states = {};
  loading: boolean;
  isMobile: boolean;
  roleType: string | null = null;
  emptyImg = 'assets/images/no-cart.png';
  vehicleType: any = localStorage.getItem('vehicleType');

  // vehicle details
  make1: any;
  model1: string;
  year1: string;
  variant1: string;
  fuelType: string;
  registrationNumber: string;
  variantKey: any;
  rowKey: any;
  // list + totals
  wishlistList: any[] = [];
  wishlistCount = 0;
  wishlistSubTotal = 0;
  sparesDiscount = 0;
  wishlistGrandTotal = 0;

  // shipping (fetched via AspCartService, same amount+garage based calculation cart uses)
  shippingCharges: any = 0;
  avoidShippingCharges: any;

  addedWishlist: any[] = [];
  isRequestExistsPopupOpen: boolean = false;
  existingRequest: any = null;
  existingRequestId: any;
  regNo: any;
  isPopupOpen: boolean = false;
  successRequestId: any;
  successRequestCreatedAt: any;
  isUpdateFlow: boolean = false;
  vin: any;

  get vehicleData(): any {
  return {
    make: this.make1,
    model: this.model1,
    year: this.year1,
    variant: this.variant1,
    fuel: this.fuelType,
    registrationNumber: this.registrationNumber,
    variantKey: this.variantKey,
    rowKey: this.rowKey
  };
}

  @ViewChild('dynamicContainers', { read: ViewContainerRef }) containers!: ViewContainerRef;
  @ViewChild('bottomSheetTemplate') bottomSheetTemplate!: TemplateRef<any>;

  constructor(
    private router: Router,
    private location: Location,
    private toastr: ToastrService,
    private bottomSheet: MatBottomSheet,
    private resolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private aspLoadingService: AspLoadingService,
    private aspLoginService: AspLoginService,
    private aspRequestWishlistService: AspRequestWishlistService,
    private aspCartService: AspCartService,
    private aspInstantOrderQuoteService: AspInstantOrderQuoteService,
  ) {
    this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => { this.isMobile = result.matches; });
    this.states['shake'] = 'shakestart';
  }

  ngOnInit(): void {
    this.roleType = localStorage.getItem('roleType');
    this.aspLoginService.checkLogin();
    this.aspLoadingService.show();

    this.getWishlist();
    this.wishlistDetails();

    this.aspLoadingService.hide();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.getWishlist();
         this.wishlistDetails();
      }
    });
  }

  ngAfterViewInit() {
    this.loadingMsg();
    this.cdr.detectChanges();
  }

  loadingMsg() {
    const factory = this.resolver.resolveComponentFactory(AspLoadingComponent);
    if (this.containers) {
      const componentRef = this.containers.createComponent(factory);
      (componentRef.instance as AspLoadingComponent).getLoadingMsg();
    }
  }

  /** Builds vehicle header info from addedWishlist (same pattern as cart's cardeails) */
  wishlistDetails() {
    const dataRaw = localStorage.getItem('addedWishlist');
    if (!dataRaw) {
      this.wishlistList = [];
      return;
    }

    let data: any[] = [];
    try {
      data = JSON.parse(dataRaw);
    } catch (err) {
      console.error('Error parsing addedWishlist:', err);
      this.wishlistList = [];
      return;
    }

    let allVariantKeysAreEqual = true;
    let firstVariantKey = '';

    data.forEach(item => {
      Object.entries(item).forEach(([key, wishlistItem]: [string, any]) => {
        if (firstVariantKey === '') {
          firstVariantKey = wishlistItem.variantKey;
        } else if (firstVariantKey !== wishlistItem.variantKey) {
          allVariantKeysAreEqual = false;
        }

        if (allVariantKeysAreEqual) {
          this.make1 = wishlistItem.selectedMake;
          this.model1 = wishlistItem.selectedModel;
          this.year1 = wishlistItem.selectedYear;
          this.variant1 = wishlistItem.variant;
          this.fuelType = wishlistItem.selectedFuel;
          this.registrationNumber = wishlistItem.registrationNumber;
          this.variantKey = wishlistItem.variantKey;
          this.rowKey = wishlistItem.rowKey;
          this.vin = wishlistItem.vin || localStorage.getItem('vin') || ''; 
        } else {
          this.make1 = '';
          this.model1 = '';
          this.year1 = '';
          this.variant1 = '';
          this.fuelType = '';
          this.registrationNumber = '';
          this.rowKey = '';
          this.vin = '';
        }
      });
    });
  }

  getWishlist() {
    const dataRaw = JSON.parse(localStorage.getItem('addedWishlist') || 'null');
    this.wishlistList = [];
    this.wishlistCount = 0;
    this.wishlistSubTotal = 0;
    this.sparesDiscount = 0;

    if (!dataRaw || !dataRaw[0]) {
      this.wishlistGrandTotal = 0;
      return;
    }

    Object.values(dataRaw[0]).forEach((item: any) => {
      this.wishlistCount++;
      this.wishlistSubTotal += (item.mrp * item.cart_qty);
      this.sparesDiscount += ((item.mrp - item.sellingPrice) * item.cart_qty);
      this.wishlistList.push(item);
    });

    this.wishlistGrandTotal = this.wishlistSubTotal - this.sparesDiscount;
    this.addedWishlist = dataRaw;

    // if (!this.isMobile) {
    //   const el = document.getElementsByClassName('wishlist_count_num')[0] as HTMLElement;
    //   if (el) {
    //     el.innerHTML = this.wishlistCount > 0
    //       ? `${this.wishlistCount} ${this.wishlistCount === 1 ? 'item' : 'items'}`
    //       : 'Empty';
    //   }
    // } else {
    //   const el = document.getElementsByClassName('wishlist_count_mobile')[0] as HTMLElement;
    //   if (el) {
    //     el.innerHTML = this.wishlistCount > 0
    //       ? `<div class="cart_count">${this.wishlistCount}</div>`
    //       : '';
    //   }
    // }

    // Populate shippingCharges / avoidShippingCharges so the price-details row has
    // something to render (mirrors asp-cart.component.ts's getShippingCharges()).
    this.getShippingCharges();
  }

  /** Same amount+garage based shipping calculation the cart page uses. */
  getShippingCharges() {
    const garageKey = localStorage.getItem('garageKey');
    if (!this.wishlistGrandTotal || !garageKey) {
      return;
    }

    this.aspCartService.getShippingCharges(this.wishlistGrandTotal, garageKey).subscribe(
      (result: any) => {
        const res = JSON.parse(JSON.stringify(result));
        if (res.code === 200) {
          this.shippingCharges = res.data.shippingCharges;
          this.avoidShippingCharges = res.data.avoidShippingCharges;
          const grandAmount = res.data.cartValue;
          this.wishlistGrandTotal = grandAmount + this.shippingCharges;
        }
      },
      (error) => {
        console.error('Error fetching shipping charges:', error);
      }
    );
  }

  addItem(count: number, itemKey: string) {
    const countval = count + 1;
    const dataRaw = JSON.parse(localStorage.getItem('addedWishlist') || 'null');
    const wishlistData = dataRaw?.[0] || {};

    if (wishlistData[itemKey]) {
      wishlistData[itemKey].cart_qty = countval;
    }

    this.addedWishlist[0] = wishlistData;
    localStorage.setItem('addedWishlist', JSON.stringify(this.addedWishlist));
    this.getWishlist();
    this.updateWishlistBadge();
    window.dispatchEvent(new Event('wishlistUpdated'));
  }

  removeItem(count: number, itemKey: string) {
    const countval = count - 1;
    const dataRaw = JSON.parse(localStorage.getItem('addedWishlist') || 'null');
    const wishlistData = dataRaw?.[0] || {};

    if (countval > 0) {
      if (wishlistData[itemKey]) {
        wishlistData[itemKey].cart_qty = countval;
      }
    } else {
      const removedName = wishlistData[itemKey]?.name || 'Item';
      if (wishlistData[itemKey]) {
        delete wishlistData[itemKey];
      }
      this.toastr.error(removedName + ' removed from wishlist', 'Request Wishlist');
    }

    this.addedWishlist[0] = wishlistData;
    localStorage.setItem('addedWishlist', JSON.stringify(this.addedWishlist));

    if (Object.keys(wishlistData).length === 0) {
      localStorage.removeItem('addedWishlist');
    }

    this.getWishlist();
    this.updateWishlistBadge();
    window.dispatchEvent(new Event('wishlistUpdated'));
  }

  deleteItem(item: string) {
    const dataRaw = JSON.parse(localStorage.getItem('addedWishlist') || 'null');
    const newData = {};

    if (dataRaw?.[0]) {
      Object.values(dataRaw[0]).forEach((item2: any) => {
        if (item2.key !== item) {
          newData[item2.key] = item2;
        }
      });
    }

    this.addedWishlist[0] = newData;
    localStorage.setItem('addedWishlist', JSON.stringify(this.addedWishlist));
    this.getWishlist();
    this.updateWishlistBadge();
    window.dispatchEvent(new Event('wishlistUpdated'));
  }

  addMore() {
    this.router.navigate(['spare-parts-list']);
  }

  goBack(): void {
    this.location.back();
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
    this.shakeMe('shake');
  }

  shakeMe(stateVar: string) {
    this.states[stateVar] = (this.states[stateVar] === 'shakestart' ? 'shakeend' : 'shakestart');
  }

  shakeEnd(stateVar: string, event) {
    this.states[stateVar] = 'shakeend';
  }

  browseParts() {
    this.router.navigate(['home']);
  }

  /** Main action: submit the wishlist as a request */
  // createRequest(): void {
  //   if (!this.wishlistList || this.wishlistList.length === 0) {
  //     this.toastr.error('Add spares before creating a request', 'Request Wishlist');
  //     return;
  //   }

  //   const garageKey = localStorage.getItem('garageKey') || '';
  //   const userKey = localStorage.getItem('spareUserKey') || '';

  //   const items = this.wishlistList.map(item => ({
  //     requestItemId: null,
  //     partNumber: item.partNumber || null,
  //     quoteLineItemId: 0,
  //     partName: item.name || '',
  //     quantity: item.cart_qty || 1,
  //     availableStock: item.quantity || 0,
  //     partType: item.partType || null,
  //     brandName: item.brand?.name || '',
  //     mrp: item.mrp || 0,
  //     discount: item.discount || 0,
  //     vendorId: item.vendorId || 0,
  //     deliveryTime: item.deliveryTime || '',
  //     sellingPrice: item.sellingPrice || 0,
  //     inputName: item.name || ''
  //   }));

  //   const requestBody: any = {
  //     garageKey: garageKey,
  //     wrongPartNames: '',
  //     variantKey: this.variantKey || '',
  //     userType: 'pitstopspare',
  //     requestType: 'web',
  //     spareGarageId: localStorage.getItem('merchantId'),
  //     regNo: (this.registrationNumber || '').replace(/["\s]/g, ''),
  //     manufacturingYear: this.year1 || '',
  //     variant: this.variant1 || '',
  //     vinNo: this.vin || '',
  //     fuelType: this.fuelType || '',
  //     make: this.make1 || '',
  //     model: this.model1 || '',
  //      rowKey: this.rowKey || '',
  //     items: items,
  //     userKey: userKey
  //   };

  //   this.aspLoadingService.show();
  //   this.aspInstantOrderQuoteService.createQuotation(requestBody).subscribe({
  //     next: (response: any) => {
  //       this.aspLoadingService.hide();
  //       if (response.code === 200) {
  //         const data = response.data;
  //         const requestId = data?.spareRequest?.requestId || data?.requestId;

  //         this.toastr.success('Request created successfully', 'Request Wishlist');

  //         localStorage.removeItem('addedWishlist');
  //         window.dispatchEvent(new Event('wishlistUpdated'));

  //         this.router.navigate(['/request-summary'], { queryParams: { requestId } });
  //       } else {
  //         this.toastr.error(response.message || 'Failed to create request', 'Request Wishlist');
  //       }
  //     },
  //     error: (error) => {
  //       this.aspLoadingService.hide();
  //       console.error('Error creating quotation:', error);
  //       this.toastr.error('Failed to create request. Please try again.', 'Request Wishlist');
  //     }
  //   });
  // }

  createRequest(reCreateRequest: boolean = false): void {
    if (!this.wishlistList || this.wishlistList.length === 0) {
      this.toastr.error('Add spares before creating a request', 'Request Wishlist');
      return;
    }

    const garageKey = localStorage.getItem('garageKey') || '';
    const userKey = localStorage.getItem('spareUserKey') || '';

    const items = this.wishlistList.map(item => ({
      brandName: item.brand?.name || '',
      discount: item.discount || 0,
      inputName: item.name || '',
      mrp: item.mrp || 0,
      partName: item.name || '',
      partNumber: item.partNumber || '',
      quantity: item.cart_qty || 1,
      quoteLineItemId: 0,
      sellingPrice: item.sellingPrice || 0,
      vendorId: String(item.vendorId || 0)
    }));

    const requestBody: any = {
      fuelType: this.fuelType || localStorage.getItem('fuelType') || '',
      garageKey: garageKey,
      isExistRequest: false,
      isInsurance: false,
      items: items,
      kitFlow: false,
      make: this.make1 || '',
      manufacturingYear: this.year1 || '',
      model: this.model1 || '',
      reCreateRequest: reCreateRequest,
      regNo: (this.registrationNumber || '').replace(/["\s]/g, ''),
      requestType: 'web',
      rowKey: this.rowKey || '',
      spareGarageId: localStorage.getItem('merchantId'),
      userKey: userKey,
      userType: 'pitstopspare',
      variant: this.variant1 || '',
      variantKey: this.variantKey || '',
      vinNo: this.vin || '',
      wrongPartNames: ''
    };

    this.aspLoadingService.show();
    this.aspInstantOrderQuoteService.createQuotation(requestBody).subscribe({
      next: (response: any) => {
        this.aspLoadingService.hide();

        if (response.code === 200) {
          const data = response.data;
          const requestId = data?.spareRequest?.requestId || data?.requestId;
          const createdAt = data?.spareRequest?.requestCreatedAt || data?.requestCreatedAt;

          localStorage.removeItem('addedWishlist');
          this.updateWishlistBadge();
          window.dispatchEvent(new Event('wishlistUpdated'));

          this.isRequestExistsPopupOpen = false;
          this.existingRequest = null;

          this.successRequestId = requestId;
          this.successRequestCreatedAt = createdAt;
          this.isUpdateFlow = false;
          this.isPopupOpen = true;

        } 
        else if (response.code === 1103 || response.message?.includes('Spare request already exist')) {
          const match = response.data?.description?.match(/id\s*:\s*(\d+)/);
          this.existingRequestId = match?.[1];
          this.regNo = this.registrationNumber;

          if (this.existingRequestId) {
            this.checkExistingRequest();
          } else {
            this.toastr.error('REQUEST ALREADY EXIST');
          }

        } else {
          this.toastr.error(response.message || 'Failed to create request', 'Request Wishlist');
        }
      },
      error: (error) => {
        this.aspLoadingService.hide();
        console.error('Error creating quotation:', error);
        this.toastr.error('Failed to create request. Please try again.', 'Request Wishlist');
      }
    });
  }

  // createRequest(): void {
  //   if (!this.wishlistList || this.wishlistList.length === 0) {
  //     this.toastr.error('Add spares before creating a request', 'Request Wishlist');
  //     return;
  //   }

  //   const garageKey = localStorage.getItem('garageKey') || '';
  //   const userKey = localStorage.getItem('spareUserKey') || '';

  //   const items = this.wishlistList.map(item => ({
  //     brandName: item.brand?.name || '',
  //     discount: item.discount || 0,
  //     inputName: item.name || '',
  //     mrp: item.mrp || 0,
  //     partName: item.name || '',
  //     partNumber: item.partNumber || '',
  //     quantity: item.cart_qty || 1,
  //     quoteLineItemId: 0,
  //     sellingPrice: item.sellingPrice || 0,
  //     vendorId: String(item.vendorId || 0)
  //   }));

  //   const requestBody: any = {
  //     fuelType: this.fuelType || '',
  //     garageKey: garageKey,
  //     isExistRequest: false,
  //     isInsurance: false,
  //     items: items,
  //     kitFlow: false,
  //     make: this.make1 || '',
  //     manufacturingYear: Number(this.year1) || 0,
  //     model: this.model1 || '',
  //     reCreateRequest: false,
  //     regNo: (this.registrationNumber || '').replace(/["\s]/g, ''),
  //     requestType: 'web',
  //     rowKey: this.rowKey || '',
  //     spareGarageId: localStorage.getItem('merchantId'),
  //     userKey: userKey,
  //     userType: 'pitstopspare',
  //     variant: this.variant1 || '',
  //     variantKey: this.variantKey || '',
  //     vinNo: this.vin || '',
  //     wrongPartNames: ''
  //   };

  //   this.aspLoadingService.show();
  //   this.aspInstantOrderQuoteService.createQuotation(requestBody).subscribe({
  //     next: (response: any) => {
  //       this.aspLoadingService.hide();
  //       if (response.code === 200) {
  //         const data = response.data;
  //         const requestId = data?.spareRequest?.requestId || data?.requestId;

  //         this.toastr.success('Request created successfully', 'Request Wishlist');

  //         localStorage.removeItem('addedWishlist');
  //         window.dispatchEvent(new Event('wishlistUpdated'));

  //         this.router.navigate(['/request-summary'], { queryParams: { requestId } });
  //       } else {
  //         this.toastr.error(response.message || 'Failed to create request', 'Request Wishlist');
  //       }
  //     },
  //     error: (error) => {
  //       this.aspLoadingService.hide();
  //       console.error('Error creating quotation:', error);
  //       this.toastr.error('Failed to create request. Please try again.', 'Request Wishlist');
  //     }
  //   });
  // }

  openBottomSheet(): void {
    this.bottomSheet.open(this.bottomSheetTemplate, { panelClass: 'custom-bottom-sheet1' });
  }

  closeBottomSheet(): void {
    if (this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
  }
  checkExistingRequest() {
    const spareGarageId = localStorage.getItem('merchantId');
    if (!spareGarageId && !this.existingRequestId) {
      console.warn('Missing spareGarageId or requestId');
      return;
    }

    this.aspLoadingService.show();
    this.aspInstantOrderQuoteService
      .getSpareRequest('pitstopSpare', spareGarageId, this.existingRequestId)
      .subscribe({
        next: (response: any) => {
          this.aspLoadingService.hide();
          if (response) {
            this.existingRequest = response;
            this.isRequestExistsPopupOpen = true;
          } else {
            this.toastr.error('Something went wrong.');
          }
        },
        error: (err) => {
          this.aspLoadingService.hide();
          console.error('API Error:', err);
          this.toastr.error('Failed to fetch request details.');
        }
      });
  }

  closeRequestExistsPopup() {
    this.isRequestExistsPopupOpen = false;
    this.existingRequest = null;
  }

  startFreshRequest() {
    this.closeRequestExistsPopup();
    this.createRequest(true); // reCreateRequest = true
  }


  // "Add Items to Existing" — merge current wishlist items into the existing request
  addItemsToExistingRequest() {
    if (!this.existingRequest?.requestId) {
      this.toastr.error('No request selected for update');
      return;
    }

    const garageKey = localStorage.getItem('garageKey') || '';
    const userKey = localStorage.getItem('spareUserKey') || '';

    const items = this.wishlistList.map(item => ({
      brandName: item.brand?.name || '',
      discount: item.discount || 0,
      inputName: item.name || '',
      mrp: item.mrp || 0,
      partName: item.name || '',
      partNumber: item.partNumber || '',
      quantity: item.cart_qty || 1,
      quoteLineItemId: 0,
      sellingPrice: item.sellingPrice || 0,
      vendorId: String(item.vendorId || 0)
    }));

    const requestBody: any = {
      fuelType: this.fuelType || localStorage.getItem('fuelType') || '',
      garageKey: garageKey,
      isExistRequest: true,
      isInsurance: false,
      items: items,
      kitFlow: false,
      make: this.make1 || '',
      manufacturingYear: this.year1 || '',
      model: this.model1 || '',
      reCreateRequest: false,
      regNo: (this.registrationNumber || '').replace(/["\s]/g, ''),
      requestId: this.existingRequest.requestId,
      requestType: 'web',
      rowKey: this.rowKey || '',
      spareGarageId: localStorage.getItem('merchantId'),
      userKey: userKey,
      userType: 'pitstopspare',
      variant: this.variant1 || '',
      variantKey: this.variantKey || '',
      vinNo: this.vin || '',
      wrongPartNames: ''
    };

    this.aspLoadingService.show();
    this.aspInstantOrderQuoteService.createQuotation(requestBody).subscribe({
      next: (response: any) => {
        this.aspLoadingService.hide();

        if (response.code === 200) {
          const data = response.data;
          const createdAt = data?.spareRequest?.requestCreatedAt || data?.requestCreatedAt || null;

          localStorage.removeItem('addedWishlist');
          this.updateWishlistBadge();
          window.dispatchEvent(new Event('wishlistUpdated'));

          const updatedRequestId = this.existingRequest.requestId;
          this.closeRequestExistsPopup();

          this.successRequestId = updatedRequestId;
          this.successRequestCreatedAt = createdAt;
          this.isUpdateFlow = true;
          this.isPopupOpen = true;

        } else {
          this.toastr.error(response.message || 'Update failed');
        }
      },
      error: (err) => {
        this.aspLoadingService.hide();
        console.error('Update error:', err);
        this.toastr.error('Something went wrong');
      }
    });
  }
  closeSuccessPopup(): void {
    this.isPopupOpen = false;
  }

  goToRequestDetails(): void {
    localStorage.removeItem('carNumber');
    localStorage.removeItem('selectedMake');
    localStorage.removeItem('selectedModel');
    localStorage.removeItem('variant');
    localStorage.removeItem('fuelType');
    localStorage.removeItem('selectedYear');
    localStorage.removeItem('variantKey');
    localStorage.removeItem('rowKey');

    this.isPopupOpen = false;

    const activeUrl = this.router.url;

    if (activeUrl.includes('/request-details')) {
      window.location.reload();
    } else {
      this.router.navigate(['/request-details'], {
        queryParams: { id: this.successRequestId }
      }).then(() => {
        window.location.reload();
      });
    }
  }
  updateWishlistBadge(): void {
  const dataRaw = localStorage.getItem('addedWishlist');
  let count = 0;
  if (dataRaw) {
    try {
      const wishlistData = JSON.parse(dataRaw)?.[0] || {};
      count = Object.keys(wishlistData).length;
    } catch {}
  }

  const desktopEl = document.getElementsByClassName('wishlist_count_num')[0] as HTMLElement;
  if (desktopEl) {
    desktopEl.innerHTML = count > 0
      ? `${count} ${count === 1 ? 'item' : 'items'}`
      : 'Empty';
  }

  const mobileEl = document.getElementsByClassName('wishlist_count_mobile')[0] as HTMLElement;
  if (mobileEl) {
    mobileEl.innerHTML = count > 0 ? `<div class="cart_count">${count}</div>` : '';
  }
}
onScroll(): void {
  console.log('Scrolled');
}
}